import { render, staticRenderFns } from "./FundBonus.vue?vue&type=template&id=31d2d645&scoped=true&"
import script from "./FundBonus.vue?vue&type=script&lang=js&"
export * from "./FundBonus.vue?vue&type=script&lang=js&"
import style0 from "./FundBonus.vue?vue&type=style&index=0&id=31d2d645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2d645",
  null
  
)

export default component.exports